import { CountryCode } from '@rover/constants/src/geography/geo.constants';
import { EnhancedPersonSitterProfile } from '@rover/rsdk/src/apiClient/latest/model/enhancedPersonSitterProfile';
import useCurrentUserShim from '@rover/shared/js/hooks/useCurrentUserShim';
import useIsBHUserShim from '@rover/shared/js/hooks/useIsBHUserShim';

import { ELIGIBLE_COUNTRIES } from '../../../bright-horizons-checkout/components/BHHowToPay/constants';

import { useRevampProfileContext } from './useRevampProfileContext';

type RevampCtaData = {
  sitterData: EnhancedPersonSitterProfile;
  serviceType: string | undefined;
  setServiceType: (serviceType: string) => void;
  selectedService: EnhancedPersonSitterProfile['services'][number] | undefined;
  serviceDisplayName: string | undefined;
  serviceIsAway: boolean | undefined;
  cancellationPolicy: string | undefined;
  isBrightHorizonsUser: boolean;
  isNonEligibleCountry: boolean;
};

export const useRevampCta = (): RevampCtaData => {
  const { sitterData, serviceType, setServiceType } = useRevampProfileContext();
  const { user } = useCurrentUserShim();
  const countryCode = user?.address?.countryCode || CountryCode.US;
  const isBrightHorizonsUser = useIsBHUserShim();
  const isNonEligibleCountry = !!countryCode && !ELIGIBLE_COUNTRIES.includes(countryCode);

  const selectedService = sitterData.services.find((s) => s.slug === serviceType);

  const serviceDisplayName = selectedService?.displayName;
  const serviceIsAway = selectedService?.isAway;
  const cancellationPolicy = selectedService?.meta?.cancellationPolicy;

  return {
    sitterData,
    serviceType,
    setServiceType,
    selectedService,
    serviceDisplayName,
    serviceIsAway,
    cancellationPolicy,
    isBrightHorizonsUser,
    isNonEligibleCountry,
  };
};
